'use strict';

angular.module('licensure.helpers')
    .factory('PortalPermissions', ['$q', '$state', 'CMSSites', '$rootScope', 'Cache', '$http', function ($q, $state, CMSSites, $rootScope, Cache, $http) {
        var portalPermissions = null;
        var gettingPermissions = false;

        var getPermissions = function () {
            var d = $q.defer();
            if (portalPermissions == null) {
                if ($rootScope.offline) {
                    Cache.get('portal_permission', 'LICENSURE').then(function (permissionObject) {
                        portalPermissions = permissionObject.permissions;
                        d.resolve(portalPermissions);
                    }).catch(function (response) {
                        d.reject(response.data);
                    });
                }
                else {
                    if (!gettingPermissions) {
                        gettingPermissions = true;
                        var arr = [];
                        var promise = null;

                        if ($rootScope.state && $rootScope.state.current && $rootScope.state.current.params) {
                            promise = CMSSites.get();
                        }
                        else {
                            promise = CMSSites.getByEnterprise($rootScope.enterpriseID);
                        }
                        promise.then(function (s) {
                            if (s != null) {
                                s.portal_pages.forEach(function (p) {
                                    if (arr[p.state] == null || arr[p.state].visible < p.visible) {
                                        arr[p.state] = { visible: p.visible, required_login: p.required_login, name: p.name };
                                    }
                                })
                            }
                            portalPermissions = arr;
                            gettingPermissions = false;
                            $rootScope.$broadcast('PortalPermissions:finish');

                            var permissionObject = {};
                            permissionObject.PRODUCTNAME = 'LICENSURE';
                            permissionObject.permissions = portalPermissions;

                            Cache.save('portal_permission', permissionObject, 'PRODUCTNAME').then(function () {
                                d.resolve(portalPermissions);
                            });
                        });
                    }
                    else {
                        $rootScope.$on('PortalPermissions:finish', function () {
                            d.resolve(portalPermissions);
                        });
                    }
                }
            }
            else {
                d.resolve(portalPermissions);
            }

            return d.promise;
        }

        var getByAddress = function (address) {
            var d = $q.defer();

            $http
                .get(apiLocation + '/api/Core/PortalPage/?actionKeyword=&address=' + encodeURIComponent(address), {
                    params: {}
                })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    d.reject(response.data);
                });

            return d.promise;
        }

        var view = function (state) {
            var d = $q.defer();

            if (state == null) {
                state = $state.current.name;
            }
            getPermissions().then(function (permissions) {
                if (permissions[state] !== undefined) {
                    d.resolve(($rootScope.userAccount != null && $rootScope.userAccount.super) || permissions[state].visible);
                } else {
                    d.resolve(false);
                }
            });

            return d.promise;
        }

        return {
            view: view,

            viewByAddress: function (address) {
                var d = $q.defer();
                getByAddress(address).then(function (page) {
                    if (page && page.state) {
                        view(page.state).then(function (access) {
                            d.resolve({ access: access, requiredLogin: page.requiredLogin });
                        });
                    }
                    else {
                        d.resolve(null);
                    }
                }).catch(function (response) {
                    d.reject(response.data);
                });

                return d.promise;
            },

            getPermissions: getPermissions
        }
    }])
;